export const cropperDimensions = {
    asset: {
        width: 640,
        height: 360
    },
    logoAsset: {
        width: 600,
        height: 600
    },
    bannerAsset: {
        width: 640,
        height: 360
    },
    // Shareable TV leaderboard theme backgrounds (wide headers/footers)
    backgroundTop: {
        width: 4096,
        height: 1077
    },
    backgroundBottom: {
        width: 4096,
        height: 485
    },
    backgroundBackground: {
        width: 1920,
        height: 1080
    }
}